module.exports = __webpack_public_path__ + "img/70m3.be5bce6a.jpg";